"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetRelatedChallengeData = resetRelatedChallengeData;
exports.watchResetRelatedChallengeData = watchResetRelatedChallengeData;
exports["default"] = exports.resetsSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _actions2 = _interopRequireDefault(require("../challenge/actions"));

var _actions3 = _interopRequireDefault(require("../checkout/actions"));

var _actions4 = _interopRequireDefault(require("../instantWin/actions"));

var _actions5 = _interopRequireDefault(require("../products/actions"));

var _actions6 = _interopRequireDefault(require("../rankings/actions"));

var _olyEngineUtils = require("@sportheroes/oly-engine-utils");

var _marked = _regenerator["default"].mark(resetRelatedChallengeData),
    _marked2 = _regenerator["default"].mark(watchResetRelatedChallengeData);

function resetRelatedChallengeData(action) {
  var _action$payload, challenge, userChallenge, _ref, _ref$registration, registration, isInstantWin, isRaceChallenge, isPaidRegistration, isTeamChallenge, isCurrentUserRegistered;

  return _regenerator["default"].wrap(function resetRelatedChallengeData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, challenge = _action$payload.challenge, userChallenge = _action$payload.userChallenge;
          _ref = challenge || {}, _ref$registration = _ref.registration, registration = _ref$registration === void 0 ? {} : _ref$registration;
          isInstantWin = _olyEngineUtils.challengeUtils.isInstantWin(challenge);
          isRaceChallenge = _olyEngineUtils.challengeUtils.isRaceChallenge(challenge);
          isPaidRegistration = _olyEngineUtils.challengeUtils.isPaidRegistration(registration);
          isTeamChallenge = _olyEngineUtils.challengeUtils.isTeamChallenge(challenge);
          isCurrentUserRegistered = _olyEngineUtils.challengeUtils.isCurrentUserRegisteredNew({
            challenge: challenge,
            userChallenge: userChallenge
          });
          _context.next = 9;
          return (0, _effects.put)(_actions2["default"].resetChallenge());

        case 9:
          if (!isInstantWin) {
            _context.next = 12;
            break;
          }

          _context.next = 12;
          return (0, _effects.put)(_actions4["default"].resetInstantWinData());

        case 12:
          if (!isRaceChallenge) {
            _context.next = 15;
            break;
          }

          _context.next = 15;
          return (0, _effects.put)(_actions6["default"].resetRanking());

        case 15:
          if (!isTeamChallenge) {
            _context.next = 18;
            break;
          }

          _context.next = 18;
          return (0, _effects.put)(_actions2["default"].resetUserGroupChallenge());

        case 18:
          if (!isPaidRegistration) {
            _context.next = 23;
            break;
          }

          _context.next = 21;
          return (0, _effects.put)(_actions3["default"].resetCheckout());

        case 21:
          _context.next = 23;
          return (0, _effects.put)(_actions5["default"].resetProducts());

        case 23:
          if (!isCurrentUserRegistered) {
            _context.next = 29;
            break;
          }

          _context.next = 26;
          return (0, _effects.put)(_actions2["default"].resetUserChallenge());

        case 26:
          if (!isRaceChallenge) {
            _context.next = 29;
            break;
          }

          _context.next = 29;
          return (0, _effects.put)(_actions6["default"].resetUserChallengeRanking());

        case 29:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function watchResetRelatedChallengeData() {
  return _regenerator["default"].wrap(function watchResetRelatedChallengeData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].resetRelatedChallengeData), resetRelatedChallengeData);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var resetsSagas = function resetsSagas() {
  return [(0, _effects.fork)(watchResetRelatedChallengeData)];
};

exports.resetsSagas = resetsSagas;
var _default = resetsSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map